import React from "react";
import HubSpotCompanyModalPicker from "components/Picker/HubSpotCompanyPicker/HubSpotCompanyModalPicker";
import GenericHubSpotPanel from "HubSpot/GenericHubSpotPanel";
import HubSpotLifecycleTag from "./HubSpotLifecycleTag";
import { YesNoText } from "components/ValidatedFields/YesNoRadioGroup";
interface Props {
  company: server.dto.Company;
}

export const HubSpotCompanyPanel = (props: Props) => {
  return <GenericHubSpotPanel
    initialHubSpotId={props.company.hubSpotCompanyId}
    urlToHubSpotEntity={(id) => `https://app.hubspot.com/contacts/5257648/record/0-2/${id}/`}
    title="HubSpot"
    apiKey="hubspot-company-section"
    collapsible={{
      start: "open",
      uniqueRowId: "hubspot-company-section",
      persist: true,
    }}

    fetch={window.CoreApi.HubSpot.GetCompany}
    link={{
      type: "autolink",
      link: id => window.CoreApi.Company.SetHubSpotCompanyId({ companyId: props.company.companyId, hubSpotCompanyId: id }),
      unlink: () => window.CoreApi.Company.SetHubSpotCompanyId({ companyId: props.company.companyId, hubSpotCompanyId: null }),
    }}
    create={{
      api: () => window.CoreApi.HubSpot.CreateCompany({ systemOneCompanyId: props.company.companyId }),
      createButtonLabel: "Create"
    }}
    renderPicker={onLink =>
      <HubSpotCompanyModalPicker
        value={null}
        required={false}
        canCreateNew={false}
        validatorKey="hubSpotCompany"
        onChange={v => onLink(v.id)}
      />
    }
    dataFields={hsCompany => [
      {
        key: "hubSpotName",
        label: "Name",
        render: () => <div>{hsCompany.name}</div>,
      }, {
        key: "hubSpotAddress",
        label: "Address",
        render: () => <div>{[hsCompany.city, hsCompany.countryName].filter(Boolean).join(", ")}</div>,
      }, {
        key: "hubspotLifecycleStage",
        label: "Lifecycle Stage",
        render: () => <HubSpotLifecycleTag hsCompany={hsCompany} />,
      }, {
        key: "hubspotExCustomer",
        label: "Ex-customer",
        render: () => <YesNoText value={hsCompany.exCustomer} />,
      }
    ]}
  />
}

export default HubSpotCompanyPanel;